import axios from 'api/axios';

export const sendQuestion = (data: API.FeedbackDto) =>
    axios<API.SuccessAnswer | API.BadRequestDto>({
        url: 'feedback',
        data
    });
